import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';
import { FormikProps } from 'formik';
import { ViewStepVM } from 'civil-status/view-models/step-form';

interface DocumentProps {
  formContext: FormikProps<ViewStepVM>;
}

const DocumentComponent = ({ formContext }: DocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      {(formContext.values?.document?.files || [])?.length > 0 ? (
        <Accordion
          expanded={open}
          onChange={() => {
            setOpen(!open);
          }}
        >
          <AccordionSummary
            aria-controls="accordion-attachments-content"
            id="accordion-attachments-header"
            expandIcon={<ExpandMore />}
          >
            <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              Allegati
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Form values={formContext.values.document} />
          </AccordionDetails>
        </Accordion>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

DocumentComponent.displayName = 'Accordion Document Component';

const Document = memo(DocumentComponent);

export default Document;
